/* eslint-disable jsdoc/require-jsdoc */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { apiFeatureKey, ApiHealthState } from '../../entities';

export const selectState = createFeatureSelector<ApiHealthState>(apiFeatureKey);
export const selectApiHealthIsOnline = createSelector(selectState, x => x.isOnline);
export const selectApiHealthState = createSelector(selectState, x => x.healthState);
export const selectApiHealthStateByUrl = (serverUrl: string) => createSelector(selectApiHealthState, x => x[serverUrl]);
